module.exports = __webpack_public_path__ + "img/miri.6b97868d.png";